<div class="grid grid-cols-12 py-10 bg-gray-50 min-h-screen">

  <div class="col-span-12 lg:col-span-8 lg:col-start-3 px-4">
    <p class="text-center text-gray-900 text-4xl font-extrabold font-['Inter'] leading-10 mb-10">Minha Conta</p>
    <!-- Tabs Header -->
    <div class="mb-8 lg:hidden">
      <label for="account-section" class="mb-2 block text-sm font-medium text-gray-900">Seção</label>
      <select
        id="account-section"
        class="block w-full rounded-md border border-gray-300 bg-white p-3 text-sm font-medium text-gray-900 focus:border-blue-500 focus:ring-blue-500"
        [value]="activeTab"
        (change)="onMobileTabChange($event)">
        @for (tab of accountTabs; track tab.id) {
          <option [value]="tab.id">{{ tab.label }}</option>
        }
      </select>
    </div>

    <div class="hidden lg:flex mb-8 bg-white rounded-md shadow p-1">
      <button (click)="switchTab('perfil')"
              [ngClass]="activeTab === 'perfil' ? 'bg-gray-100 text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'"
              class="flex-1 py-3 px-4 rounded-md text-sm font-medium font-['Inter'] transition-all flex items-center justify-center gap-2">
        <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-width="2" d="M7 17v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3Zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
        </svg>
        Dados pessoais & plano
      </button>
      <button (click)="switchTab('notificacoes')"
              [ngClass]="activeTab === 'notificacoes' ? 'bg-gray-100 text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'"
              class="flex-1 py-3 px-4 rounded-md text-sm font-medium font-['Inter'] transition-all flex items-center justify-center gap-2">
        <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5.365V3m0 2.365a5.338 5.338 0 0 1 5.133 5.368v1.8c0 .851.174 1.694.512 2.482l.753 1.748A1 1 0 0 1 17.486 18H6.514a1 1 0 0 1-.912-1.407l.753-1.748A6.337 6.337 0 0 0 6.867 12.365V10.733a5.338 5.338 0 0 1 5.133-5.368Zm0 0c.485 0 .976.066 1.45.197M12 18v1.1c0 1.049-.851 1.9-1.9 1.9h-1.1"/>
        </svg>
        Notificações
      </button>
    </div>

    <!-- Tab Content: Profile & Plan -->
    <div *ngIf="activeTab === 'perfil'" class="space-y-6">
      <!--  SUBSCRIPTION STATUS -->
      <div class="bg-white p-6 rounded-md shadow">
        <div class="flex justify-between items-center mb-6">
          <h2 class="text-gray-900 text-xl font-bold font-['Inter']">Plano atual</h2>
          @if (stripeSubscriptions.length > 0) {
            <button (click)="openCancelModal()" class="text-blue-600 text-sm font-medium font-['Inter'] hover:underline">Cancelar conta</button>
          } @else if (!stripeLoading ) {
            <button (click)="reactivatePlan()" class="text-blue-600 text-sm font-medium font-['Inter'] hover:underline">Reativar plano</button>
          }
        </div>
          @if (stripeLoading) {
            <div class="inline-block px-3 py-1 bg-blue-100 text-blue-800 rounded-md text-sm font-medium font-['Inter']">
              <div class="flex items-center gap-2">
                <svg class="animate-spin h-4 w-4 text-blue-800" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span>Carregando...</span>
              </div>
            </div>
          } @else if (stripeSubscriptions.length > 0) {
            <div class="inline-block px-3 py-1 bg-blue-100 text-blue-800 rounded-md text-sm font-medium font-['Inter']">
              @for (subscription of stripeSubscriptions; track subscription.id) {
                @for (item of subscription.items.data; track item.id) {
                  @if (subscription.status === 'trialing' && subscription.trial_days_left > 0){
                    Trial ativo • Faltam {{ subscription.trial_days_left }} dia(s) • {{ item.price.nickname }} Ativo
                  } @else if (subscription.status === 'active' && subscription.trial_days_left == 0 && subscription.cancel_at == true){
                    Conta Desativada com acesso ativo • Você tem acesso até dia {{ subscription.current_period_end * 1000 | date:'dd/MM/yyyy' }} • {{ item.price.nickname }}
                  } @else if (subscription.status === 'active'){
                    {{ item.price.nickname }} Ativo
                  }
                }
              }
            </div>

          } @else {
            <div class="inline-block px-3 py-1 bg-red-100 text-red-800 rounded-md text-sm font-medium font-['Inter']">
              Conta Desativada
            </div>
          }
      </div>

      @if(stripeSubscriptions.length > 0){
      <!--  PLAN DETAILS -->
      <div class="bg-white p-6 rounded-md shadow">
        <div class="flex justify-between items-center mb-8">
          <h2 class="text-gray-900 text-xl font-bold font-['Inter']">Meu plano e pagamento</h2>
          <button (click)="openPaymentPortal()" class="text-blue-600 text-sm font-medium font-['Inter'] hover:underline">
            Editar meu plano e/ou dados de pagamento
          </button>
        </div>

        @if (stripeLoading) {
          <div class="flex justify-center py-10">
            <div role="status">
              <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
              </svg>
              <span class="sr-only">Carregando...</span>
            </div>
          </div>
        } @else if (stripeSubscriptions.length > 0) {
          @for (subscription of stripeSubscriptions; track subscription.id) {
            @for (item of subscription.items.data; track item.id) {
              <div class="grid grid-cols-1 md:grid-cols-2 gap-y-6 gap-x-12 mb-8">
                <div>
                  <p class="text-gray-900 text-base font-semibold font-['Inter'] mb-1">Plano atual</p>
                  <p class="text-gray-500 text-base font-normal font-['Inter']">{{ item.price.nickname }}</p>
                </div>
                <div>
                  <p class="text-gray-900 text-base font-semibold font-['Inter'] mb-1">Valor</p>
                  <p class="text-gray-500 text-base font-normal font-['Inter']">{{ (item.price.unit_amount || 0) / 100 | currency: ((item.price.currency || 'BRL') | uppercase):'symbol-narrow' }}</p>
                </div>
                <div>
                  <p class="text-gray-900 text-base font-semibold font-['Inter'] mb-1">Plano criado</p>
                  <p class="text-gray-500 text-base font-normal font-['Inter']">{{ (item.current_period_start * 1000) | date:'dd/MM/yyyy' }}</p>
                </div>
                <div>
                  <p class="text-gray-900 text-base font-semibold font-['Inter'] mb-1">Data de renovação de plano</p>
                  <p class="text-gray-500 text-base font-normal font-['Inter']">{{ (item.current_period_end * 1000) | date:'dd/MM/yyyy' }}</p>
                </div>
                <div>
                  <p class="text-gray-900 text-base font-semibold font-['Inter'] mb-1">Status de cancelamento</p>
                  <p class="text-gray-500 text-base font-normal font-['Inter']">{{ subscription.cancel_at ? 'Cancelamento agendado' : 'Renovação automática' }}</p>
                </div>
                @if (subscription.trial_days_left > 0) {
                  <div>
                    <p class="text-gray-900 text-base font-semibold font-['Inter'] mb-1">Dias de teste grátis restantes</p>
                    <p class="text-gray-500 text-base font-normal font-['Inter']">{{ subscription.trial_days_left }} dias</p>
                  </div>
                }
              </div>
            }
          }
        } @else {
          <div class="mb-8 text-gray-500 italic">Nenhum plano ativo encontrado.</div>
        }

        <div>
          <p class="text-gray-900 text-base font-semibold font-['Inter'] mb-4">Metodo de pagamento</p>
          <div class="space-y-3">
            @for(item of stripePaymentMethods; track item){
              <div class="max-w-md p-4 bg-gray-50 rounded-md border border-gray-200 flex justify-between items-center">
                <div class="flex flex-col">
                  <span class="text-gray-900 text-base font-medium font-['Inter']">Visa ...{{ item.card?.last4 }}</span>
                  <span class="text-gray-500 text-xs font-normal font-['Inter']">Vencimento {{ item.card?.exp_month }}/{{ item.card?.exp_year }}</span>
                </div>
                <div class="text-blue-800">
                  @if(item.card?.brand == 'visa'){
                    <svg class="w-12 h-8" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                      <path fill-rule="evenodd" d="M2 6.3c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-12Zm12.5 3.2c.4 0 .8 0 1.1.2l-.1 1h-.1a2 2 0 0 0-1-.3c-.5 0-.7.3-.7.5s.2.3.7.5c.7.4 1 .8 1 1.3 0 1-.8 1.7-2.2 1.7-.6 0-1.1-.2-1.4-.3l.2-1h.1c.4.2.7.3 1.2.3.4 0 .8-.2.8-.5 0-.2-.2-.3-.7-.6-.5-.2-1.1-.6-1.1-1.3 0-.9 1-1.5 2.2-1.5Zm3.5 0h1l1 4.8h-1.2l-.2-.7H17l-.3.7h-1.3l1.9-4.4c.1-.3.3-.3.7-.3Zm-6.2 0h-1.3l-.8 4.8H11l.8-4.8Zm-4.5 3.3-.1-.7-.5-2.2c0-.3-.3-.3-.6-.4h-2v.1l1.2.5.1.2 1.1 4H8l2-4.7H8.7l-1.3 3.2Z" clip-rule="evenodd"/>
                    </svg>
                  } @else if (item.card?.brand == 'mastercard'){
                    <svg class="w-12 h-8" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                      <path fill-rule="evenodd" d="M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4Zm5.178 12.137a4.137 4.137 0 1 1 1.036-8.144A6.113 6.113 0 0 0 8.726 12c0 1.531.56 2.931 1.488 4.006a4.114 4.114 0 0 1-1.036.131ZM10.726 12c0-1.183.496-2.252 1.294-3.006A4.125 4.125 0 0 1 13.315 12a4.126 4.126 0 0 1-1.294 3.006A4.126 4.126 0 0 1 10.726 12Zm4.59 0a6.11 6.11 0 0 1-1.489 4.006 4.137 4.137 0 1 0 0-8.013A6.113 6.113 0 0 1 15.315 12Z" clip-rule="evenodd"/>
                    </svg>
                  } @else {
                    <svg class="w-12 h-8" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M6 14h2m3 0h5M3 7v10a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1Z"/>
                    </svg>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
      }

      <!--  PERSONAL INFO -->
      <div class="bg-white p-6 rounded-md shadow">
        <div class="flex justify-between items-center mb-6">
          <h2 class="text-gray-900 text-xl font-bold font-['Inter']">Meus dados</h2>
          <button type="button" data-modal-target="editUserModal" data-modal-toggle="editUserModal" class="text-blue-600 text-sm font-medium font-['Inter'] hover:underline">
            Editar meus dados
          </button>
        </div>
        <div class="text-gray-900 text-lg font-bold font-['Inter'] mb-6">Informações pessoais</div>

        <div class="space-y-6">
          <div>
            <p class="text-gray-900 text-base font-semibold font-['Inter'] mb-1">Full name</p>
            <p class="text-gray-500 text-base font-normal font-['Inter']">{{ userAttributes.name }} {{ userAttributes.family_name }}</p>
          </div>

          <div>
            <p class="text-gray-900 text-base font-semibold font-['Inter'] mb-1">Email</p>
            <p class="text-gray-500 text-base font-normal font-['Inter']">{{ userAttributes.email }}</p>
          </div>

          <div>
            <p class="text-gray-900 text-base font-semibold font-['Inter'] mb-1">Endereço</p>
            <p class="text-gray-500 text-base font-normal font-['Inter']">
              {{ profileForm.get('city')?.value }}{{ profileForm.get('city')?.value && profileForm.get('state')?.value ? ', ' : '' }}{{ profileForm.get('state')?.value }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab Content: Notifications -->
    <div *ngIf="activeTab === 'notificacoes'" class="space-y-6">
      <!-- Preferences -->
      <div class="bg-white p-6 rounded-md shadow">
        <h2 class="text-gray-900 text-xl font-bold font-['Inter'] mb-8">Preferências</h2>

        <div class="space-y-6">
          <div class="flex items-start gap-4">
            <label class="inline-flex items-center cursor-pointer mt-1">
              <input type="checkbox"
                     class="sr-only peer"
                     [checked]="profileForm.get('newsletter')?.value"
                     (change)="updateNewsletter($event)">
              <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
            </label>
            <div>
              <p class="text-gray-900 text-base font-semibold font-['Inter'] leading-tight">Novidades da Casato Brasil</p>
              <p class="text-gray-500 text-sm font-normal font-['Inter'] mt-1">Receba melhorias e comunicados importantes.</p>
            </div>
          </div>

          <div class="flex items-start gap-4">
            <label class="inline-flex items-center cursor-pointer mt-1">
              <input type="checkbox"
                     class="sr-only peer"
                     [checked]="profileForm.get('real_estate_alerts')?.value"
                     (change)="updateRealEstateAlerts($event)">
              <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
            </label>
            <div>
              <p class="text-gray-900 text-base font-semibold font-['Inter'] leading-tight">Alertas dos seus imóveis salvos</p>
              <p class="text-gray-500 text-sm font-normal font-['Inter'] mt-1">Receba avisos sobre atualizações e mudanças relevantes nos imóveis que você adicionou aos favoritos.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Alerts List -->
      <div class="bg-white p-6 rounded-md shadow">
        <div class="flex justify-between items-center mb-6">
          <h2 class="text-gray-900 text-xl font-bold font-['Inter']">Meus alertas</h2>
          <button (click)="openCreateNotificationModal()" class="text-blue-600 text-sm font-medium font-['Inter'] hover:underline">
            Criar alerta
          </button>
        </div>

        <div class="relative overflow-x-auto shadow-md sm:rounded-md">
          <table class="w-full text-sm text-left rtl:text-right">
            <thead class="bg-gray-50 text-gray-500 text-xs font-semibold font-['Inter'] uppercase">
              <tr>
                <th scope="col" class="px-4 py-3">Título</th>
                <th scope="col" class="px-4 py-3">Estado</th>
                <th scope="col" class="px-4 py-3">Cidade</th>
                <th scope="col" class="px-4 py-3">Tipo</th>
                <th scope="col" class="px-4 py-3">Desconto</th>
                <th scope="col" class="px-4 py-3">Ações</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100">
              <tr *ngIf="notifications.length === 0">
                <td colspan="6" class="py-10 text-center text-gray-500 italic">Nenhum alerta configurado.</td>
              </tr>
              <tr *ngFor="let notification of notifications" class="bg-white hover:bg-gray-50">
                <td class="px-4 py-4 font-medium text-gray-900">{{ notification.title }}</td>
                <td class="px-4 py-4 text-gray-500">{{ notification.state }}</td>
                <td class="px-4 py-4 text-gray-500">{{ notification.city }}</td>
                <td class="px-4 py-4 text-gray-500">
                  {{ isArray(notification.type) ? $any(notification.type).join(', ') : notification.type }}
                </td>
                <td class="px-4 py-4 text-gray-500">{{ (notification.discount ?? 0) | number:'1.0-0' }}%</td>
                <td class="px-4 py-4 flex gap-3">
                  <button (click)="openEditNotificationModal(notification)" class="text-blue-600 font-medium hover:underline">Editar</button>
                  <button (click)="requestDeleteNotification(notification.id)" class="text-blue-600 font-medium hover:underline">Deletar</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!--<pre>-->
<!--  {{ stripeSubscriptions | json }}-->
<!--</pre>-->

<!-- Account Cancellation Modal -->
<app-account-cancel-modal
  *ngIf="showCancelModal"
  [isSaving]="cancellingAccount"
  [errorMessage]="cancelError"
  (confirmed)="confirmCancelSubscription()"
  (cancelled)="closeCancelModal()">
</app-account-cancel-modal>

<!-- Modal: Edit User Data (same as before) -->
<div id="editUserModal" tabindex="-1" aria-hidden="true" class="hidden fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
  <div class="relative w-full max-w-4xl max-h-full mx-auto">
    <div class="relative bg-white rounded-md shadow">
      <div class="flex items-center justify-between p-4  ">
        <h3 class="text-xl font-semibold text-gray-900">
          Editar meus dados
        </h3>
        <button type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-md text-sm w-8 h-8 ms-auto inline-flex justify-center items-center" data-modal-hide="editUserModal" aria-label="Fechar">
          ✕
        </button>
      </div>
      <div class="p-6 space-y-6">
        <form [formGroup]="profileForm" (ngSubmit)="saveProfile()" class="space-y-6">
          <h1 class="justify-start text-gray-900 text-lg font-bold font-['Inter'] leading-tight">Seus dados</h1>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block self-stretch justify-start text-gray-900 text-sm font-medium font-['Inter'] leading-tight mb-2">Nome</label>
              <input type="text" formControlName="name" class="w-full border px-4 py-3 bg-gray-50 rounded-md border-gray-300 self-stretch justify-center text-gray-500 text-sm font-normal font-['Inter'] focus:ring-blue-500 focus:border-blue-500"/>
            </div>
            <div>
              <label class="block self-stretch justify-start text-gray-900 text-sm font-medium font-['Inter'] leading-tight mb-2">Sobrenome</label>
              <input type="text" formControlName="family_name" class="w-full border px-4 py-3 bg-gray-50 rounded-md border-gray-300 self-stretch justify-center text-gray-500 text-sm font-normal font-['Inter'] focus:ring-blue-500 focus:border-blue-500"/>
            </div>
            <div>
              <label class="block self-stretch justify-start text-gray-900 text-sm font-medium font-['Inter'] leading-tight mb-2">E-mail</label>
              <input type="email" formControlName="email" class="w-full border px-4 py-3 bg-gray-50 rounded-md border-gray-300 self-stretch justify-center text-gray-500 text-sm font-normal font-['Inter'] focus:ring-blue-500 focus:border-blue-500" placeholder="seu@email.com"/>
              <p class="text-xs text-gray-500 mt-1">Alterar o e-mail pode exigir confirmação.</p>
            </div>
            <div>
              <label class="block self-stretch justify-start text-gray-900 text-sm font-medium font-['Inter'] leading-tight mb-2">Estado</label>
              <input type="text" formControlName="state" class="w-full border px-4 py-3 bg-gray-50 rounded-md border-gray-300 self-stretch justify-center text-gray-500 text-sm font-normal font-['Inter'] focus:ring-blue-500 focus:border-blue-500"/>
            </div>
            <div>
              <label class="block self-stretch justify-start text-gray-900 text-sm font-medium font-['Inter'] leading-tight mb-2">Cidade</label>
              <input type="text" formControlName="city" class="w-full border px-4 py-3 bg-gray-50 rounded-md border-gray-300 self-stretch justify-center text-gray-500 text-sm font-normal font-['Inter'] focus:ring-blue-500 focus:border-blue-500"/>
            </div>
          </div>

          <div *ngIf="saveError" class="text-red-600 text-sm">{{ saveError }}</div>
          <div *ngIf="saveSuccess" class="text-green-600 text-sm">{{ saveSuccess }}</div>
          <div *ngIf="verificationMessage" class="text-amber-600 text-sm">{{ verificationMessage }}</div>

          <div class="flex gap-3 justify-end">
            <button type="submit" [disabled]="saving || loading || profileForm.invalid" class="bg-blue-600 text-white px-4 py-2 rounded disabled:opacity-50">
              {{ saving ? 'Salvando...' : 'Salvar alterações' }}
            </button>
          </div>
        </form>

        <form [formGroup]="passwordForm" (ngSubmit)="changePassword()" class="mt-8 space-y-6 border-t pt-8">
          <h2 class="text-lg font-semibold">Alterar Senha</h2>
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <div class="col-md-1">
              <div class="">
                <label class="block self-stretch justify-start text-gray-900 text-sm font-medium font-['Inter'] leading-tight mb-2">Senha atual</label>
                <input type="password" formControlName="currentPassword" class="w-full border px-4 py-3 bg-gray-50 rounded-md border-gray-300 self-stretch justify-center text-gray-500 text-sm font-normal font-['Inter'] focus:ring-blue-500 focus:border-blue-500"/>
              </div>
              <div class="mt-4">
                <label class="block self-stretch justify-start text-gray-900 text-sm font-medium font-['Inter'] leading-tight mb-2">Nova senha</label>
                <input type="password" formControlName="newPassword" class="w-full border px-4 py-3 bg-gray-50 rounded-md border-gray-300 self-stretch justify-center text-gray-500 text-sm font-normal font-['Inter'] focus:ring-blue-500 focus:border-blue-500"/>
              </div>
              <div class="mt-4">
                <label class="block self-stretch justify-start text-gray-900 text-sm font-medium font-['Inter'] leading-tight mb-2">Confirmar nova senha</label>
                <input type="password" formControlName="confirmNewPassword" class="w-full border px-4 py-3 bg-gray-50 rounded-md border-gray-300 self-stretch justify-center text-gray-500 text-sm font-normal font-['Inter'] focus:ring-blue-500 focus:border-blue-500"/>
              </div>
            </div>
          </div>

          <div *ngIf="pwdError" class="text-red-600 text-sm">{{ pwdError }}</div>
          <div *ngIf="pwdSuccess" class="text-green-600 text-sm">{{ pwdSuccess }}</div>

          <div class="flex gap-3 justify-end">
            <button type="submit" [disabled]="pwdSaving || passwordForm.invalid" class="bg-blue-600 text-white px-4 py-2 rounded disabled:opacity-50">
              {{ pwdSaving ? 'Salvando...' : 'Alterar senha' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Notification Modal Component -->
<app-notification-modal
  *ngIf="showNotificationModal"
  [notification]="selectedNotification"
  (closeModal)="closeNotificationModal()"
  (notificationSaved)="onNotificationSaved($event)">
</app-notification-modal>

<!-- Delete Confirmation Modal -->
<div *ngIf="showDeleteNotificationModal" class="fixed inset-0 z-[60] flex items-center justify-center bg-black/50">
  <div class="bg-white rounded-md shadow max-w-md w-full mx-4">
    <div class="p-6">
      <h3 class="text-lg font-semibold text-gray-900 mb-2">Excluir notificação</h3>
      <p class="text-sm text-gray-600">Tem certeza que deseja excluir esta notificação? Esta ação não pode ser desfeita.</p>
    </div>
    <div class="px-6 py-4 flex justify-end gap-3 border-t">
      <button (click)="cancelDeleteNotification()" class="px-4 py-2 text-sm rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50">Cancelar</button>
      <button (click)="confirmDeleteNotification()" class="px-4 py-2 text-sm rounded-md bg-red-600 text-white hover:bg-red-700">Excluir</button>
    </div>
  </div>
</div>
